import React from 'react'
import { Container, Image, Row, Col, Button, Nav, NavDropdown, DropdownButton, Dropdown } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { useState } from "react";
import { useMisAuth } from '../contexts/misAuth';


export const Header = ({ user, onLogout }) => {
    // const { isMisUserAuthenticated } = useMisAuth();

    // not needed as we have seperated the mis and consent page 
    // const handleMISUserNavigation = () => {
    //     if (isMisUserAuthenticated) {
    //         navigate("/mis-user");
    //     } else {
    //         navigate("/mis-user-login");
    //     }
    // };
    const location = useLocation();
    const navigate = useNavigate();
    
    const handleLogout = () => {
        onLogout(location.pathname);
    };

    const handleProfileNavigation = () => {
        navigate('/manage-profile');
    };



    return (
        <header className='shadow bg-white sticky-top py-3'>
            <Container fluid className='px-4'>
                <Row>
                    <Col md={6}>
                        <figure className="m-0">
                            <Image src='/images/logo-dark.svg' />
                        </figure>
                    </Col>
                    <Col md={6} className='text-end align-self-center d-flex justify-content-end align-items-center'>
                        {/* {
                            // not needed as we have seperated the mis and the consent page 
                            // user?.role !== 'gst_user' ?
                                <NavDropdown title="Report" id="basic-nav-dropdown" style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                    <NavDropdown.Item href="/mis">Mis</NavDropdown.Item>
                                    <NavDropdown.Item onClick={handleMISUserNavigation}>
                                        Mis User
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href='/home' >Home</NavDropdown.Item>

                                </NavDropdown> 
                                // :
                                // null
                        } */}
                        {user && (
                            <DropdownButton id="dropdown-item-button" variant='primary py-1 px-3' className='btn-square rounded-circle' title={user.emailId?.charAt(0).toUpperCase()}>
                                <Dropdown.Item as="button" onClick={handleProfileNavigation}>Manage Profile</Dropdown.Item>
                                <Dropdown.Item as="button" onClick={handleLogout}>Logout</Dropdown.Item>
                            </DropdownButton>
                        )}
                    </Col>
                </Row>
            </Container>
        </header>
    )
}
